import { Link } from "react-router-dom";
import Book from "../assets/book.png";
import Dots from "../assets/dots.png";
import GreenBlub from "../assets/green_blub_1.png";
import GreenBlub2 from "../assets/green_blub_2.png";
import LinkedInLogo from "../assets/linkedin_logo.png";
import EmailLogo from "../assets/mail_logo.png";
import People from "../assets/people.png";
import Project from "../assets/project.png";
import ButtonComponent from "../components/button.component";
import InfoBannerComponent from "../components/infoBanner.component";
import "./home.page.css";
import { getExpertises, getFoerderers, getProjekte, getPublikationen, getWorkshops } from "../services/cdn.services";
import { useEffect, useState } from "react";
import { Expertise } from "../types/expertises.type";
import { ENV, getCDNOrigin } from "../utils/envReader.util";
import ExpertiseBoxComponent from "../components/expertiseBox.component";
import { PublikationenType } from "../types/publikationen.type";
import { ProjekteType } from "../types/projekte.type";
import { WorkshopType } from "../types/workshop.type";
import LanguageButton from "../components/languageButton.component";

function Home(
    props: Readonly<{
        isEnglish: boolean;
        setIsEnglish: (newValue: boolean) => void;
    }>
) {
    const { isEnglish, setIsEnglish } = props;

    //Fetch expertise data
    useEffect(() => {
        const fetchData = async () => {
            setExpertiseData(await getExpertises());
        };
        fetchData();
    }, [])
    const [expertiseData, setExpertiseData] = useState<Expertise[] | undefined>(undefined);

    //Fetch foerderers data (logos)
    useEffect(() => {
        const fetchData = async () => {
            setFoerdererData(await getFoerderers());
        };
        fetchData();
    }, [])
    const [foerdererData, setFoerdererData] = useState<any>(undefined);

    //Fetch expertise data
    useEffect(() => {
        const fetchData = async () => {
            setPublikationenData(await getPublikationen());
        };
        fetchData();
    }, [])
    const [publikationenData, setPublikationenData] = useState<PublikationenType[] | undefined>(undefined);

    //Fetch expertise data
    useEffect(() => {
        const fetchData = async () => {
            setProjekteData(await getProjekte());
        };
        fetchData();
    }, [])
    const [projekteData, setProjekteData] = useState<ProjekteType[] | undefined>(undefined);

    //Fetch expertise data
    useEffect(() => {
        const fetchData = async () => {
            setWorkshopData(await getWorkshops());
        };
        fetchData();
    }, [])
    const [workshopData, setWorkshopData] = useState<WorkshopType[] | undefined>(undefined);

    return (
        <div id="home" className="standard-page">
            <div className="banner">
                <div className="flex column gap-4">
                    <div className="flex gap-3 wrap between items-end">
                        <div className="left-container flex column gap">
                            <h1>Prof. Dr. Heike Wiesner</h1>
                            <h3>{isEnglish ? "Professor of Business Information and Communication Systems" : "Professorin für Betriebliche Informations- und Kommunikationssysteme"}</h3>
                            <p>{isEnglish ? "I am pleased that you have found your way to my homepage. Here you will find information about my CV, publications, projects, and more." : "Es freut mich, dass Sie den Weg zu meiner Homepage gefunden haben. Informationen zu meinem Lebenslauf, meinen Publikationen, Projekten und mehr finden Sie hier."}</p>
                            <div className="flex gap wrap items-center">
                                <ButtonComponent title={isEnglish ? "Learn more" : "Mehr Erfahren"} to="/projekte" />
                                <ButtonComponent type="transparent" title={isEnglish ? "Contact" : "Kontakt"} to="/kontakt" />
                                <LanguageButton onToggle={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} />
                            </div>
                        </div>
                        <div className="counter-container flex column gap-3 wrap">
                            <div className="flex items-center gap-3">
                                <img src={Book} alt="book" width="50px" height="50px" />
                                <div className="flex column">
                                    <h2>{publikationenData?.length}+</h2>
                                    <p>{isEnglish ? "Publications" : "Publikationen"}</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-3">
                                <img src={Project} alt="project" width="50px" height="50px" />
                                <div className="flex column">
                                    <h2>{projekteData?.length}+</h2>
                                    <p>{isEnglish ? "Projects" : "Projekte"}</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-3">
                                <img src={People} alt="people" width="50px" height="50px" />
                                <div className="flex column">
                                    <h2>{workshopData?.length}+</h2>
                                    <p>Workshops</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="socials flex gap-3 wrap">
                        <Link to="https://www.linkedin.com/in/heikewiesner/">
                            <img src={LinkedInLogo} alt="linkedin logo" width="25px" height="25px" />
                        </Link>
                        <Link to={`mailto:${ENV.MAIL}`}>
                            <img src={EmailLogo} alt="email logo" width="25px" height="25px" />
                        </Link>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="content">
                    <img className="no-select" src={GreenBlub} alt="greenBlub1" />
                    <img className="no-select" src={GreenBlub2} alt="greenBlub2" />
                    <img className="no-select" src={Dots} alt="dots1" />
                    <img className="no-select" src={Dots} alt="dots2" />

                    <div className="relative flex column gap-5">
                        {/* main content */}
                        <InfoBannerComponent setIsEnglish={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} />

                        {expertiseData &&
                            <div className="flex column gap-3">
                                <div className="flex w-100 center">
                                    <h5>{isEnglish ? "My Areas of Expertise" : "Meine Schwerpunkte"}</h5>
                                </div>

                                <div className="grid-expertise">
                                    {expertiseData?.map((expertise: Expertise, index: number) => (
                                        <ExpertiseBoxComponent
                                            key={index}
                                            title={isEnglish ? expertise.en_titel : expertise.titel}
                                            description={isEnglish ? expertise.en_beschreibung : expertise.beschreibung}
                                            logoURL={`${getCDNOrigin() + expertise.logo.formats.thumbnail.url}`}
                                        />
                                    ))}
                                </div>

                                <div className="flex center">
                                    <ButtonComponent title={isEnglish ? "Learn more" : "Mehr Erfahren"} to={"/publikationen"} />
                                </div>
                            </div>
                        }

                        {/* niemals angucken, versuchen zu beheben oder sonstiges -- es ist zwecklos, es funktionert! aber wie lange? ES IST EIN WUNDER LEBOWSKI!! */}
                        {foerdererData &&
                            <div className="foerderer" style={{ height: `calc((130px * ${Math.ceil(foerdererData?.length / 4)}) + (30px * ${Math.floor(foerdererData?.length / 4)}) + 170px)` }}>
                                <div className="foerderer-text">
                                    <p>{isEnglish ? "Collaborations and/or funding (including) by" : "Kooperationen und/oder Förderungen (u.a.) durch"}</p>
                                </div>
                                <div className="foerderer-container">
                                    <div className="logo-container">
                                        {foerdererData?.map((data: any, index: number) => (
                                            <a key={index} href={data.url} target="_blank" className="no-select flex center items-center">
                                                <img alt="logo" src={`${getCDNOrigin() + data.logo.url}`} width="130px" height="130px" />
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div style={{ height: 100 }} /> {/* FOOTER ABSTAND <3 */}
                </div>
            </div>
        </div>
    );
}

export default Home;